import { actionTypeKeys } from "./actionTypeKeys";
import { Dispatch } from "redux";
import { Customer, CustomerInfoDto, CustomerValidationResponse } from "../types/customer";
import CustomersApi from "../api/customersApi";
import { setAppTitleBar } from "./appTitleBarActions";
import RepresentativesApi from "../api/representativesApi";

export const authenticationSuccess = (customer: Customer) => {
  return {
    type: actionTypeKeys.AUTHENTICATION_SUCCESS,
    customer
  };
};

export const guestSignin = () => {
  return {
    type: actionTypeKeys.GUEST_SIGN_IN
  };
};

export const authenticationError = (error: any) => {
  return {
    type: actionTypeKeys.AUTHENTICATION_FAILED,
    error
  };
};

export const logoutSuccess = () => {
  return {
    type: actionTypeKeys.LOGOUT_SUCCESS
  };
};

export const signInServiceRepSuccess = (email: string) => {
  return {
    type: actionTypeKeys.SERVICE_REP_SIGN_IN_SUCCESS,
    email
  };
};

export const appointmentCreatedBy = (name: string) => {
  return {
    type: actionTypeKeys.APPT_CREATED_BY,
    name
  };
};

export const signInFirstTimeGuest = () => {
  return (dispatch: Dispatch) => {
    dispatch(guestSignin());
  };
};

export const validateCustomer = (info: CustomerInfoDto, persist: boolean = true) => {
  return async (dispatch: Dispatch): Promise<boolean> => {
    try {
      const validationResponse: CustomerValidationResponse = await CustomersApi.validateCustomer(info);

      // Augment validation response with user-entered data for Redux state
      // Server doesn't return PII to prevent brute force disclosure
      const customer: Customer = {
        id: validationResponse.id,
        firstName: validationResponse.firstName,
        lastName: validationResponse.lastName,
        last4Ssn: info.data.last4Ssn,  // Use what user entered
        email: '',                      // Will be entered in contact step
        phone: '',                      // Will be entered in contact step
        memberNumber: '',               // Not available from validation
        member: false                   // Server will filter categories based on DB member status
      };

      // Removed sessionStorage persistence to prevent PII storage on client
      dispatch(authenticationSuccess(customer));
      return true;
    } catch (error) {
      dispatch(authenticationError(error));
      return false;
    }
  };
};

export const signInServiceRep = (email: string) => {
  return async (dispatch: Dispatch): Promise<boolean> => {
    try {
      const valid = await RepresentativesApi.validateRepresentative(email);
      if (valid) {
        dispatch(signInServiceRepSuccess(email));
        dispatch(appointmentCreatedBy(email));
      }
      return valid;
    } catch (error) {
      dispatch(authenticationError(error));
      return false;
    }
  };
};

export const logout = (dispatch: Dispatch) => {
  dispatch(logoutSuccess());
  dispatch(setAppTitleBar({ description: "", title: "" }));
};
